import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Clock, Factory, Truck } from 'lucide-react';
export function CapabilityBar() {
  const capabilities = [{
    icon: <Clock className="w-8 h-8 text-gold mb-3" strokeWidth={1.5} data-id="element-25" />,
    text: 'Más de 25 años de trayectoria'
  }, {
    icon: <Factory className="w-8 h-8 text-gold mb-3" strokeWidth={1.5} data-id="element-26" />,
    text: 'Planta de producción de alta capacidad'
  }, {
    icon: <Truck className="w-8 h-8 text-gold mb-3" strokeWidth={1.5} data-id="element-27" />,
    text: 'Logística e Instalación en toda Colombia'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="bg-espresso border-b border-white/5 relative z-20 -mt-1" data-id="element-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12" data-id="element-29">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 divide-y md:divide-y-0 md:divide-x divide-white/10" data-id="element-30">
          {capabilities.map((cap, index) => <motion.div key={index} variants={itemVariants} className={`flex flex-col items-center text-center ${index !== 0 ? 'pt-8 md:pt-0' : ''} px-4`} data-id="element-31">
              {cap.icon}
              <h3 className="text-bone font-medium text-lg" data-id="element-32">{cap.text}</h3>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}